<div class="grid full-height-grid">
  <div class="col-12 md:col-5 fixed-sidebar p-0">
    <app-login-info />
  </div>
  <div class="col-12 md:col-7 scrollable-content pt-6">
    <app-sign-up-request />
  </div>
</div>
